/**
 * ParametroRelatorioCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {ParametroRelatorio} from '@/model/resource/ParametroRelatorio'

/* TODO: review generated class */
@HttpExclude()
export class ParametroRelatorioCollection extends PageCollection<
  ParametroRelatorio
> {
  constructor() {
    super(ParametroRelatorio)
  }

  queryAsPage() {
    return this.listParametroRelatorio()
  }

  async listParametroRelatorio() {
    return await Request.get(`/admin/parametro-relatorio`, {
      params: this.params,
    })
      .name('listParametroRelatorio')
      .as(this)
      .getResponse()
  }

  async listCsvParametroRelatorio() {
    return await Request.get(`/admin/parametro-relatorio/csv`, {
      params: this.params,
    })
      .name('listCsvParametroRelatorio')
      .as(this)
      .getResponse()
  }
}
